export const likertOptions = [1, 2, 3, 4, 5]
export const scaleOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
export const treatmentOptions = ['Metotreksat', 'Sulfasalazyna', 'Cyklosporyna', 'Leflunomid', 'Inne']